<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="shopId">
        <span slot="label">
          <a-tooltip>
            选择门店<template slot="title">选择门店为该门店创建积分商品</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.shopIds" mode="multiple" placeholder="请选择门店（可多选）" allow-clear show-search :filter-option="filterOption">
          <a-select-option v-for="item in shopList" :key="item.id" :value="item.id">
            {{ item.shopName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!--选择商品-->
      <a-form-model-item label="选择商品" prop="goodsId">
        <a-button type="dashed" @click="openProdSelect" danger>
          <span style="color: dodgerblue"> 选择商品</span>
        </a-button>
      </a-form-model-item>
      <!-- 数据展示 -->
      <a-row>
        <a-col :span="24">
          <a-table
            :loading="goodsLoading"
            rowKey="id"
            :size="tableSize"
            :columns="goodsColumns"
            :data-source="form.goodsList"
            :pagination="false"
            :bordered="tableBordered"
            style="margin-bottom: 20px;">
            <template slot="picture" slot-scope="text, record">
              <div>
                <img v-if="record.picture" :src="record.picture" style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
              </div>
            </template>
            <span slot="categoryId" slot-scope="text, record">
              {{getCategoryNameById(record.categoryId)}}
            </span>
            <span slot="brandId" slot-scope="text, record">
              {{getBrandNameById(record.brandId)}}
            </span>
            <span slot="status" slot-scope="text, record">
               <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status"/>
            </span>
          </a-table>
        </a-col>
      </a-row>

      <!-- SKU价格设置 -->
      <a-row v-if="form.goodsId">
        <a-col :span="24">
          <div style="margin-bottom: 10px; font-weight: bold;">SKU价格设置</div>
          <template v-if="form.skuList && form.skuList.length > 0">
            <a-alert message="请为每个SKU设置现金价和积分价,现金价和积分价不能同时为0" type="info" style="margin-bottom: 10px;" show-icon />
            <a-table
              :loading="skuLoading"
              rowKey="id"
              :size="tableSize"
              :columns="skuColumns"
              :data-source="form.skuList"
              :pagination="false"
              :bordered="tableBordered"
            >
              <template slot="skuPicture" slot-scope="text, record">
                <div>
                  <img v-if="record.picture" :src="record.picture" style="width:40px;height:40px;" @click="handleRecordPreview(record.picture)" alt="none"/>
                </div>
              </template>
              <template slot="price" slot-scope="text, record">
                <a-input-number
                  v-model="record.price"
                  :min="0.00"
                  :max="2147483647"
                  :precision="2"
                  placeholder="现金价"
                  style="width: 100%"
                />
              </template>
              <template slot="pointPrice" slot-scope="text, record">
                <a-input-number
                  v-model="record.pointPrice"
                  :min="0"
                  :max="2147483647"
                  :precision="0"
                  placeholder="积分价"
                  style="width: 100%"
                />
              </template>
            </a-table>
          </template>
          <a-alert v-else message="请先选择商品" type="warning" />
        </a-col>
      </a-row>

      <div class="drawer-footer">
        <a-button :style="{ marginRight: '8px' }" @click="onClose">
          取消
        </a-button>
        <a-button type="primary" @click="submitForm">
          确定
        </a-button>
      </div>
    </a-form-model>

    <!-- 预览图片 -->
    <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
      <img alt="example" style="width: 100%" :src="previewUrl" />
    </a-modal>

    <!--选择商品组件-->
    <radio-goods-select-form ref="RadioGoodsSelectForm" @goodsSelect="goodsSelect"></radio-goods-select-form>
  </a-drawer>
</template>

<script>
import { pageGoods, getGoods, addGoods, updateGoods, copyFromNormalGoods, editPointPrice, getSelectableShops } from '@/api/goodspoint/goodspoint'
import RadioGoodsSelectForm from './RadioSelectForm'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'

export default {
  name: 'PointDrawer',
  components: {
    RadioGoodsSelectForm,
    CustomDictTag
  },
  data() {
    return {
      open: false,
      formTitle: '',
      loading: false,
      skuLoading: false,
      goodsLoading: false,
      shopList: [],
      categoryList: [],
      brandList: [],
      previewImageVisible: false,
      previewUrl: '',
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        id: undefined,
        shopIds: [],
        sourceGoodsId: undefined, // 普通商品ID
        goodsId: undefined,
        goodsList: [],
        skuList: []
      },
      rules: {
        shopIds: [{ required: true, type: 'array', min: 1, message: '请至少选择一个门店', trigger: 'change' }]
      },
      goodsColumns: [
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          width: 100,
        },
        {
          title: '商品主图',
          dataIndex: 'picture',
          width: 70,
          scopedSlots: { customRender: 'picture' }
        },
        {
          title: '商品分类',
          dataIndex: 'categoryId',
          width: 80,
          scopedSlots: { customRender: 'categoryId' }
        },
        {
          title: '品牌',
          dataIndex: 'brandId',
          width: 80,
          scopedSlots: { customRender: 'brandId' }
        },
        // {
        //   title: '市场价',
        //   width: 80,
        //   dataIndex: 'marketPrice',
        // },
        {
          title: '商品价',
          width: 80,
          dataIndex: 'price',
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 70,
          scopedSlots: { customRender: 'status' }
        }
      ],
      skuColumns: [
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          width: 100,
        },
        {
          title: 'SKU图片',
          dataIndex: 'picture',
          width: 60,
          scopedSlots: { customRender: 'skuPicture' }
        },
        {
          title: '现金价(元)',
          dataIndex: 'price',
          width: 110,
          scopedSlots: { customRender: 'price' }
        },
        {
          title: '积分价',
          dataIndex: 'pointPrice',
          width: 110,
          scopedSlots: { customRender: 'pointPrice' }
        }
      ]
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleAdd() {
      this.reset()
      this.formTitle = '新增积分商品'
      this.open = true
      this.loadShopList()
      this.getCategoryList()
      this.getBrandList()
    },
    handleUpdate(row) {
      this.reset()
      this.formTitle = '修改积分商品'
      this.open = true
      this.loadShopList()
      this.getCategoryList()
      this.getBrandList()

      if (row && row.id) {
        this.loading = true
        getGoods({ id: row.id }).then(response => {
          // 从remark字段中解析源商品ID
          let sourceGoodsId = null
          if (response.data.remark) {
            const match = response.data.remark.match(/源商品ID:(\d+)/)
            if (match && match[1]) {
              sourceGoodsId = parseInt(match[1])
            }
          }

          if (sourceGoodsId) {
            // 有源商品ID，需要加载源商品信息
            this.form = {
              id: response.data.id,
              shopIds: [],
              sourceGoodsId: sourceGoodsId, // 设置源商品ID
              goodsId: sourceGoodsId,
              goodsList: [],
              skuList: []
            }
            // 加载源商品信息
            this.loadSourceGoodsInfo(sourceGoodsId)
            // 加载源商品SKU列表
            this.loadSkuList(sourceGoodsId)
            // 回填SKU价格
            if (response.data.skuList && response.data.skuList.length > 0) {
              this.$nextTick(() => {
                response.data.skuList.forEach(skuItem => {
                  const sku = this.form.skuList.find(s => s.id === skuItem.id)
                  if (sku) {
                    sku.price = skuItem.price || 0
                    sku.pointPrice = skuItem.pointPrice || null
                  }
                })
              })
            }
          } else {
            // 没有源商品ID，直接使用积分商品的SKU列表
            this.form = {
              id: response.data.id,
              shopIds: [],
              sourceGoodsId: undefined,
              goodsId: response.data.id,
              goodsList: [response.data],
              skuList: response.data.skuList ? response.data.skuList.map(sku => ({
                ...sku,
                skuId: sku.id,
                price: sku.price || 0,
                pointPrice: sku.pointPrice || null
              })) : []
            }
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },
    onClose() {
      this.open = false
      this.reset()
    },
    reset() {
      this.form = {
        id: undefined,
        shopIds: [],
        sourceGoodsId: undefined,
        goodsId: undefined,
        goodsList: [],
        skuList: []
      }
    },
    loadShopList() {
      getSelectableShops().then(response => {
        this.shopList = response.data || []
      })
    },
    // 选择商品
    openProdSelect() {
      if (!this.form.shopIds || this.form.shopIds.length === 0) {
        this.$message.warning('请先选择门店')
        return
      }
      const firstShopId = this.form.shopIds[0]
      this.$refs.RadioGoodsSelectForm.openGoods("0", [this.form.goodsId])
    },
    goodsSelect(records) {
      this.form.goodsId = records[0].id
      this.form.sourceGoodsId = records[0].id // 设置普通商品ID
      this.form.goodsList = records
      this.loadSkuList(records[0].id)
      console.log('商品选择了', this.form.goodsList)
    },
    // 加载SKU列表
    loadSkuList(goodsId) {
      console.log('开始加载SKU列表, goodsId:', goodsId)
      this.skuLoading = true

      import('@/api/goods/goods').then(({ querySkuByGoodsId, getGoods }) => {
        Promise.all([
          querySkuByGoodsId(goodsId),
          getGoods({ id: goodsId })
        ]).then(([skuResponse, goodsResponse]) => {
          console.log('获取SKU列表成功:', skuResponse.data)
          console.log('获取商品详情成功:', goodsResponse.data)

          const skuList = skuResponse.data || []
          const goodsDetail = goodsResponse.data || {}
          const specList = goodsDetail.specList || []

          // 创建规格值ID到规格名称的映射
          const specValueMap = {}
          specList.forEach(spec => {
            if (spec.specValueList) {
              spec.specValueList.forEach(specValue => {
                specValueMap[specValue.id] = {
                  specName: spec.specName,
                  specValueName: specValue.specValueName
                }
              })
            }
          })
          console.log('规格值映射:', specValueMap)

          this.form.skuList = skuList.map(sku => {
            // 解析specValueIds (格式可能是 "id1:id2:id3")
            let skuName = sku.skuName || ''
            if (sku.specValueIds) {
              const specValueIdArray = sku.specValueIds.split(':')
              const specNameArray = []
              specValueIdArray.forEach(id => {
                const specInfo = specValueMap[id]
                if (specInfo) {
                  specNameArray.push(`${specInfo.specName}:${specInfo.specValueName}`)
                }
              })
              if (specNameArray.length > 0) {
                skuName = specNameArray.join(' ')
              }
            }

            return {
              id: sku.id,
              skuId: sku.id,
              skuName: skuName,
              specValueIds: sku.specValueIds || '',
              picture: sku.picture || '',
              price: sku.price || 0,
              pointPrice: null
            }
          })
          console.log('SKU处理后数据:', this.form.skuList)
          this.skuLoading = false
        }).catch(error => {
          console.error('加载SKU列表失败:', error)
          this.skuLoading = false
        })
      })
    },
    // 加载源商品信息
    loadSourceGoodsInfo(goodsId) {
      import('@/api/goods/goods').then(({ getGoods }) => {
        getGoods({ id: goodsId }).then(response => {
          this.form.goodsList = [response.data]
        }).catch(error => {
          console.error('加载源商品信息失败:', error)
        })
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 验证商品是否选择
          if (!this.form.goodsId) {
            this.$message.error('请选择商品')
            return false
          }

          // 验证SKU价格
          if (!this.form.skuList || this.form.skuList.length === 0) {
            this.$message.error('该商品没有SKU,无法设置价格')
            return false
          }

          // 验证价格设置
          for (let i = 0; i < this.form.skuList.length; i++) {
            const sku = this.form.skuList[i]
            // if (!sku.price || sku.price <= 0) {
            //   this.$message.error(`SKU [${sku.skuName}] 的现金价必须大于0`)
            //   return false
            // }
            if (sku.pointPrice < 0) {
              this.$message.error(`SKU [${sku.skuName}] 的积分价不能小于0`)
              return false
            }
          }

          // 检查是否所有价格都为0(不能现金价和积分价同时为0)
          const allZero = this.form.skuList.every(sku => sku.price === 0 && (sku.pointPrice === 0 || sku.pointPrice === null))
          if (allZero) {
            this.$message.warning('现金价和积分价不能同时为0,至少需要设置一种价格')
            return false
          }

          this.loading = true

          // 构建提交数据
          console.log('准备提交的SKU列表:', this.form.skuList)

          if (this.form.id) {
            // 编辑模式 - 使用新接口只更新价格
            const editData = {
              pointGoodsId: this.form.id,
              skuPointPrices: this.form.skuList.map(sku => ({
                skuId: sku.id,
                price: sku.price,
                pointPrice: sku.pointPrice
              }))
            }
            console.log('编辑模式提交数据:', editData)

            editPointPrice(editData).then(response => {
              if (response.code == 20001) {
                this.$message.success('修改成功')
                this.open = false
                this.$emit('ok')
              } else {
                this.$message.error(response.msg || '操作失败')
              }
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          } else {
            // 新增模式 - 使用新接口从普通商品复制
            const addData = {
              sourceGoodsId: this.form.sourceGoodsId,
              shopIds: this.form.shopIds,
              skuPointPrices: this.form.skuList.map(sku => ({
                sourceSkuId: sku.id,
                price: sku.price,
                pointPrice: sku.pointPrice
              }))
            }
            console.log('新增模式提交数据:', addData)

            copyFromNormalGoods(addData).then(response => {
              if (response.code == 20001) {
                this.$message.success('新增成功')
                this.open = false
                this.$emit('ok')
              } else {
                this.$message.error(response.msg || '操作失败')
              }
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        }
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    getCategoryNameById(id) {
      if (!id) {
        return ""
      }
      let cateInfo = this.categoryList.find(e => e.id === id)
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return ""
      }
    },
    getBrandNameById(id) {
      if (!id) {
        return ""
      }
      let brandInfo = this.brandList.find(e => e.id === id)
      if (brandInfo) {
        return brandInfo.name
      } else {
        return ""
      }
    },
    getCategoryList() {
      import('@/api/goods/category').then(({ listCategory }) => {
        listCategory().then(response => {
          this.categoryList = response.data
        })
      })
    },
    getBrandList() {
      import('@/api/goods/brand').then(({ allBrand }) => {
        allBrand().then(response => {
          this.brandList = response.data
        })
      })
    }
  },
  computed: {
    ...mapGetters(['customDict', 'tableSize', 'tableBordered'])
  }
}
</script>

<style scoped>
.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  left: 0;
}
</style>
